// extracted by mini-css-extract-plugin
export default {"modalOverlay":"jz-z","modalContent":"kz-z","header":"lz-z","close":"mz-z"};